import { Grid } from "@mui/material";
import TimingGroup from "components/base/Hours-And-Tickets/Times/timeGroup/timeGroups";
import { PrivatePageLayout } from "components/common/layouts/Page/private";

export function TimingsPage() {
    return <PrivatePageLayout
        link={"https://images.pexels.com/photos/1834407/pexels-photo-1834407.jpeg?auto=compress&cs=tinysrgb"}
        activeLink={"tickets,prices,times"}
        activeSubLink={"times"}
        title="Timings"
    >
        <Grid container style={{ maxWidth: "1000px", margin: 'auto' }} spacing={0}>
            <Grid item xs={12}>
                <TimingGroup />
            </Grid>
        </Grid>
    </PrivatePageLayout>
}